<template>
  <el-form class="center-common-form-container" ref="commonForm" :model="formData" :rules="rules">
    <div class="form__item" v-for="(item, index) in render" :key="index" :class="{
      empty: item.hidden
    }">
      <template v-for="(dividerInfo, xxx) in divider">
        <div class="form-item__sub-title" :key="xxx" v-if="dividerInfo.relatedItem === index">
          <p>{{ dividerInfo.text }}</p>
        </div>
      </template>
      <el-form-item :label="item.hidden ? '' : item.title" :prop="index"
        :class="[item.type === 'header' ? 'headerInput' : '', item.extendClass, item.hint ? '' : 'no-hint']">
        <template v-if="!item.hidden">
          <p class="form-item__hint" v-if="item.hint">{{ item.hint }}</p>
          <template v-if="item.type === 'text'">
            <el-input type="text" v-model="form[index]" class="form-item__input"
              :class="[item.length ? item.length : '']"></el-input>
          </template>
          <template v-else-if="item.type === 'textarea'">
            <el-input :show-word-limit="item.maxlength ? true : false" :maxlength="item.maxlength" type="textarea"
              v-model="form[index]" class="form-item__input"></el-input>
          </template>
          <template v-else-if="item.type === 'select'">
            <el-select v-model="form[index]" :placeholder="item.placeholder"
              @change="item.onChange && item.onChange(arguments['0'])">
              <template v-if="item.options">
                <el-option v-for="option in item.options" :key="option.id" :label="option.name"
                  :value="item.key ? option.name : option.id"></el-option>
              </template>
            </el-select>
          </template>
          <template v-else-if="item.type === 'checkbox'">
            <el-checkbox-group v-model="form[index]" @change="checkboxOnChange" v-loading="item.loading">
              <template v-if="item.options.length > 0">
                <el-checkbox v-for="option in item.options" :key="option.id" :label="item.key ? option.name : option.id"
                  :name="index" border>{{ option.name }}</el-checkbox>
              </template>
            </el-checkbox-group>
          </template>
          <template v-else-if="item.type === 'radio'">
            <el-radio-group v-model="form[index]">
              <el-radio :label="option.id" v-for="option in item.options" :key="option.id">{{
                option.name
              }}</el-radio>
            </el-radio-group>
          </template>
          <template v-else-if="item.type === 'date'">
            <el-date-picker v-model="form[index]" type="date" value-format="yyyy-MM-dd"
              :placeholder="item.placeholder"></el-date-picker>
          </template>
          <template v-else-if="item.type === 'img' || item.type === 'file' || item.type === 'header'">
            <div class="action-item__link" v-if="item.type === 'header'">
              <img class="item-link__headpic" :src="item.fileList[0].url | filterUrl" alt />
            </div>
            <el-upload v-else :ref="`upload_${index}`" action="#"
              :list-type="item.type === 'file' ? 'text' : 'picture-card'" :auto-upload="false" :multiple="item.limit > 1"
              :limit="item.limit" :accept="item.accept ? item.accept : '.png,.jpg'" :on-exceed="function (files, fileList) {
                return fileOnExceed(files, fileList, item.limit);
              }
                " :on-change="function (file, fileList) {
    return fileOnChange(file, fileList, index);
  }
    " :on-remove="function (file, fileList) {
    return fileOnRemove(file, fileList, index);
  }
    " :file-list="item.fileList">
              <div v-if="formData[index].length < item.limit" slot="default" class="upload-bt-add"></div>
              <el-button v-if="item.type === 'header'" :data-index="index" @click="submitUpload"
                class="headpicSubmitBt">修改头像</el-button>
              <el-button size="small" type="yellow" v-if="item.type === 'file'">选择文件</el-button>
            </el-upload>
            <p class="form-item__extends" v-if="item.type === 'header' && item.extends">
              {{ item.extends }}
            </p>
          </template>
          <template v-else-if="item.type === 'rich-textarea'">
            <el-input type="textarea" v-model="form[index]" class="form-item__input --rich-text"
              :minlength="item.minlength"></el-input>
            <wang-editor :model="index" @editorChange="editorChange" :val="item.data"></wang-editor>
          </template>
          <p class="form-item__hint-ex" v-if="item.exhint">{{ item.exhint }}</p>
        </template>
      </el-form-item>
    </div>
    <slot name="hint"></slot>
    <el-form-item class="form-item__bts">
      <slot name="bts"></slot>
    </el-form-item>
  </el-form>
</template>

<script>
import { upload } from "@/api/common";
import { Message } from "element-ui";
import wangEditor from "@/components/wangEdit.vue";

export default {
  name: "user-form-container",
  components: {
    wangEditor,
  },
  props: {
    form: {
      type: Object,
      default: null,
    },
    rules: {
      type: Object,
      default: null,
    },
    render: {
      type: Object,
      default: null,
    },
    divider: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formData: this.form,
    };
  },
  filters: {
    filterUrl(val) {
      if (val) {
        var strList = val.split("https://wx.material-online.cn/Monline/public/uploads/");
        if (strList[1] && strList[1].length == 1) {
          val =
            "https://wx.material-online.cn/Monline/public/uploads/images/20220216/e8f5ddb321eab26b026d29e44a1bc249.png";
        }
        return val;
      }
    },
  },
  mounted() {
    console.log(this.formData);
  },
  methods: {
    selectOnChange(val) {
      const name = "moldOnChange";
      this.$parent[name](val);
    },
    checkboxOnChange() { },
    fileOnExceed(files, fileList, limit) {
      Message({
        type: "error",
        message: `最多选择 ${limit} 个图片，本次选择了 ${files.length} 个图片，共选择了 ${files.length + fileList.length
          } 个图片`,
      });
    },
    fileOnChange(file, fileList, index) {
      const size = this.render[index].maxsize || 5;
      if (file.size / 1024 / 1024 > size) {
        this.form[index] = [];
        this.$refs[`upload_${index}`]["0"].abort(file);
        this.$refs[`upload_${index}`]["0"].clearFiles();
        Message({
          type: "error",
          message: `文件不能超过${size}m`,
        });
        return false;
      } else {
        this.form[index] = fileList;
      }
      console.log(this.form);
    },
    fileOnRemove(files, fileList, index) {
      this.form[index] = fileList;
    },
    async onFormValidate(extendParams) {
      try {
        await this.$refs.commonForm.validate();
        let emit = "submit";
        let extendPostData = extendParams;

        if (extendPostData !== undefined) {
          const extendPost = {};
          const extendKeys = Object.keys(extendPostData);
          for (let i = 0; i < extendKeys.length; i += 1) {
            if (extendKeys[i] !== "submitType") {
              extendPost[extendKeys[i]] = extendPostData[extendKeys[i]];
            } else {
              emit = "preview";
            }
          }
          if (Object.keys(extendPost).length > 0) {
            extendPostData = extendPost;
          }
        }
        if (emit === "submit") {
          try {
            await this.uploadFiles();
          } catch (err) {
            console.log(err);
          }

          Object.assign(this.formData, extendPostData);
          console.log(this.formData, "extendPostData", extendPostData);
          this.$emit("formValidated", this.formData);
        } else {
          this.$emit("formValidatedPreveiw", this.formData);
        }
      } catch (err) {
        let error = err;
        if (error === false) {
          error = "表单没有正确填写";
        }
        this.$emit("formValidateError", error);
      }
    },
    editorChange(index, content) {
      this.form[index] = content;
    },
    async uploadFiles() {
      // 处理图片上传
      const that = this;
      const fileKeys = Object.keys(that.render).filter(
        (item) =>
          that.render[item].type === "img" ||
          that.render[item].type === "file" ||
          that.render[item].type === "header"
      );
      const defaultData = [];
      const promises = [];
      fileKeys.forEach((item, index) => {
        const preLoad = [];
        promises[index] = [];
        defaultData[index] = [];
        // console.log(that.formData, 'that.formData', item);
        const files = that.formData[item];
        console.log(item);
        console.log(that.formData);
        if (Array.isArray(files))
          files.forEach((f) => {
            if (f.raw) {
              preLoad.push(f);
            } else {
              defaultData[index].push(f.id ? f.id : f);
            }
          });
        if (preLoad.length > 0) {
          promises[index] = upload(preLoad);
        }
      });
      const uploaded = await Promise.all(promises);
      for (let i = 0; i < fileKeys.length; i += 1) {
        const getKey = that.render[fileKeys[i]].get || "id";
        if (uploaded[i].length > 0) {
          const data = uploaded[i].map((item) => item.data[getKey]);
          const obj = uploaded[i].map((item) => item.data);
          // console.log(8888888, uploaded, obj, this.form)
          if (fileKeys[i] == "su_desc" || fileKeys[i] == "install_desc") {
            that.formData[fileKeys[i]] = JSON.stringify(defaultData[i].concat(obj));
          } else {
            that.formData[fileKeys[i]] = defaultData[i].concat(data);
          }
        }
        if (Number(that.render[fileKeys[i]].limit) === 1) {
          that.formData[fileKeys[i]] = that.formData[fileKeys[i]]["0"];
        }
      }
      return Promise.resolve();
    },
    submitUpload(e) {
      const { index } = e.currentTarget.dataset;
      const obj = this.$refs[`upload_${index}`]["0"];
      obj.clearFiles();
      obj.submit();
    },
    resetField() {
      this.$refs.commonForm.resetFields();
    },
    onBeforeUpload(file) {
      console.log(file);
      return false;
    },
    onDrafts() {
      return this.formData
    }
  },
};
</script>

<style lang="scss">
.center-common-form-container {
  .el-date-editor {
    .el-input__inner {
      padding-left: 30px;
    }

    .el-input__icon {
      margin-right: 20px;
    }
  }

  .action-item__link {
    width: 7.2916666667vw;
    height: 7.2916666667vw;
    border-radius: 50%;
    overflow: hidden;

    .item-link__headpic {
      width: 100%;
      height: 100%;
    }
  }

  .form__item {
    &.empty {
      height: 0;
      overflow: hidden;
      border: 0;
    }
  }
}

.el-form-item {
  &.no-hint {
    .el-form-item__label {
      float: none;
    }
  }
}
</style>
